import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "track", "counter" ]
  static values = { count: Number }

  connect() {
    this.scrollHandler = this.throttle(this.updateCounter.bind(this), 80, { trailing: true })
    this.trackTarget.addEventListener("scroll", this.scrollHandler)
    this.updateCounter()
  }

  disconnect() {
    this.trackTarget.removeEventListener("scroll", this.scrollHandler)
    if (this.trailingTimeout) {
      clearTimeout(this.trailingTimeout)
      this.trailingTimeout = null
    }
  }

  updateCounter() {
    if (!this.hasTrackTarget || !this.hasCounterTarget || this.countValue <= 1) return

    const track = this.trackTarget
    const slideWidth = track.clientWidth
    if (slideWidth <= 0) return

    let index = Math.round(track.scrollLeft / slideWidth)
    index = Math.min(Math.max(index, 0), this.countValue - 1)
    this.counterTarget.textContent = `${index + 1}/${this.countValue}`
  }

  throttle(func, limit, options = {}) {
    let inThrottle
    let lastArgs

    const trailingCall = () => {
      if (lastArgs) {
        func.apply(this, lastArgs)
        lastArgs = null
        inThrottle = true
        this.trailingTimeout = setTimeout(() => {
          inThrottle = false
          trailingCall()
        }, limit)
      }
    }

    return function (...args) {
      if (!inThrottle) {
        func.apply(this, args)
        inThrottle = true
        this.trailingTimeout = setTimeout(() => {
          inThrottle = false
          trailingCall()
        }, limit)
      } else {
        lastArgs = args
      }
    }
  }
}
